<div>
  <span class="threshold-cell-value">{{ ($safeNavigationMigration(params()?.value) | numberFormat) ?? '-' }}</span>
</div>
